import * as preact from "preact";
import { $$ } from "../../Core/Common";
import { BaseComponent, IBaseComponentProps } from "../BaseComponent/BaseComponent";
import { Popup } from "../Popup/Popup";

export class VideoPlayer extends BaseComponent
{
    private _popup: Popup;
    private _isOpen: boolean = false;
    private _player: any;

    constructor(props: IBaseComponentProps)
    {
        super(props);
    }

    public isOpen(): boolean
    {
        return this._isOpen;
    }

    public open(videoId)
    {
        if (!this._player)
        {
            //The YT.Player api is loaded in _Layout.cshtml directly from youtube.
            this._player = new (window as any).YT.Player("YTPlayer", {
                videoId: videoId,
                playerVars: { origin: location.origin },
                host: "https://www.youtube-nocookie.com",
                events: {
                    "onReady": (event) =>
                    {
                        event.target.playVideo();
                    }
                }
            });
        }
        else
        {
            this._player.loadVideoById(videoId);
        }

        this._popup.open();
        this._isOpen = true;
    }

    private _onPopupClose(): void
    {
        this.close();
    }

    public close()
    {
        try
        {
            this._player.stopVideo()
        }
        catch { }
        this._popup.close();
        this._isOpen = false;
    }

    public render()
    {
        return (
            <Popup ref={(ref) => { this._popup = ref; }} key="data123" onClose={this._onPopupClose.bind(this)} zeroContainer={true}>
                <div class="video-container" style={{width: "100vw"}}>
                    <div id="YTPlayer"></div>
                </div>
            </Popup>
        );
    }
}
export var $$videoPlayer: VideoPlayer;
let element = preact.createElement(VideoPlayer, { ref: (ref) => { $$videoPlayer = ref } });
$$.appendChild(document.body, element);